// @project
import GTag from './GTag';
import MicrosoftClarity from './MicrosoftClarity';
import Notify from './Notify';
import GrafanaFaro from 'grafana/GrafanaFaro';

const clarityId = import.meta.env.VITE_APP_PUBLIC_CLARITY_ID || '';
const notifyId = import.meta.env.VITE_APP_PUBLIC_NOTIFY_ID || '';
const gaId = import.meta.env.VITE_APP_PUBLIC_ANALYTICS_ID || '';
const faroUrl = import.meta.env.VITE_APP_GRAFANA_FARO_URL || '';

/***************************  METRICS  ***************************/

export default function Metrics() {
  return (
    <>
      {clarityId && <MicrosoftClarity clarityId={clarityId} />}
      {notifyId && <Notify notifyId={notifyId} />}
      {gaId && <GTag gaId={gaId} />}
      {faroUrl && <GrafanaFaro />}
    </>
  );
}
